// WASLO (field report F3.4): the sample campaigns Chatwoot shows behind an empty Campaigns page,
// emptied.
//
// Copied OVER `app/javascript/dashboard/components-next/Campaigns/EmptyState/
// CampaignEmptyStateContent.js` by `deploy/branding/Dockerfile`, before `assets:precompile`. The
// tracked upstream file is never edited, so `git merge upstream` stays clean.
//
// Upstream's cards were another company's ("PaperLayer"), with a "$25 Amazon coupon" for a G2
// review. A client reading them takes them for Waslo's, or for her own. The same two export
// names, so upstream's three empty states (live chat, SMS, WhatsApp) import them unchanged and
// render only their title and subtitle. `wasloai/specs/campaign-samples.spec.js` compares the
// names with the upstream file's; services `docs/chatwoot-seam-register.md` B18.
export const ONGOING_CAMPAIGN_EMPTY_STATE_CONTENT = [];

export const ONE_OFF_CAMPAIGN_EMPTY_STATE_CONTENT = [];
